import sections from 'react-showroom-sections';
import { Div } from '../components/base';
import { Seo } from '../components/seo';
import { Sidebar } from '../components/sidebar';
import * as React from 'react';
export const DefaultHomePage = () => (React.createElement(Div, { css: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
    } },
    React.createElement(Seo, null),
    React.createElement(Div, { css: { display: 'flex', flex: 1, overflow: 'hidden' } },
        React.createElement(Sidebar, { sections: sections }),
        React.createElement(Div, { as: "main", css: {
                flex: '1',
                overflowY: 'auto',
            } },
            React.createElement(Div, { css: {
                    opacity: 0,
                } },
                React.createElement("a", { id: "__react-showroom-main__", tabIndex: -1, "aria-hidden": true }, "Main Content")),
            React.createElement(Div, { css: {
                    maxWidth: '$screenXl',
                    marginX: 'auto',
                    padding: '$6',
                } },
                React.createElement("h1", null, "React Showroom Site"))))));
//# sourceMappingURL=index.js.map